import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc.js";
dayjs.extend(utc);
import { DATE_STORAGE_FORMAT } from "cms/fields/dates/date-helpers";
import { Tabs } from "cms/shared/tabs";
import { TabContent } from "cms/shared/tabs/tab-content";

import TableRow from "@mui/material/TableRow";

import L from "leaflet";
import { MapContainer, TileLayer, useMap, ZoomControl, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-geosearch/dist/geosearch.css";
import { StepLabel, Stepper, Step, TableCell, Collapse, Table, TableBody, Button } from "@mui/material";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Config } from "config";
import { CTAHorizontalDevApps } from "mydnv/components/development-application-subscriptions/horizontal-cta";
import * as devAppService from "./devapp-service";
import { ImageGallery } from "layout/development-app/image-gallery";
import ReactDOMServer from "react-dom/server";
import Handlebars from "handlebars";
import "proj4leaflet";
import "leaflet/dist/leaflet.css";
import Lightbox from "yet-another-react-lightbox";
import Inline from "yet-another-react-lightbox/plugins/inline";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import { solid, regular } from "../../assets/icons";
const { faMessage, faInfo } = solid;
import "yet-another-react-lightbox/plugins/thumbnails.css";
import { getDevelopmentTypes, isNullOrEmpty, getPlanStatusByType } from "./devapp-util";
import { DnvDevAppError } from "./devapp-error";

const CollapsibleRow = (props) => {
    const { fieldName, fieldValue, keys, values, isArea } = props;
    const [open, setOpen] = React.useState(false);

    const formatArea = (squareMetres) => {
        return (
            <>
                <span className='no-wrap'>{squareMetres.toLocaleString("en-CA")} m<sup>2</sup>&nbsp;/</span>{" "}
                 {/* {" "}/{" "} */}
                <span className='no-wrap'>{Math.round(squareMetres * 10.7639).toLocaleString("en-CA")} ft<sup>2</sup></span>
            </>
        );
    };

    return (
        fieldValue && (
            <>
                <TableRow className={open ? "collapsible-row-parent remove-bottom-border" : "collapsible-row-parent"}>
                    <TableCell className="bold-value">{fieldName}</TableCell>
                    <TableCell className="d-flex pl-5">
                        {fieldValue}
                        {values.length > 0 && values.some((value) => value !== null) && (
                            <button
                                type="button"
                                onClick={() => setOpen(!open)}
                                title={open ? "click to collapse" : "click to expand"}
                                className="btn-expand"
                            >
                                <FontAwesomeIcon icon={open ? solid.faChevronUp : solid.faChevronDown} />
                            </button>
                        )}
                    </TableCell>
                </TableRow>
                <TableRow className={open ? "add-bottom-border collapsible-row-child" : "collapsible-row-child"}>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0, width: "100%" }} colSpan={2}>
                        <Collapse in={open} style={{ width: "100%" }} timeout="auto" unmountOnExit>
                            <Table>
                                <TableBody>
                                    {values.length > 0 &&
                                        values.map(
                                            (rowValue, i) =>
                                                rowValue?.value !== null &&
                                                rowValue?.value !== 0 &&
                                                rowValue !== null &&
                                                rowValue !== 0 &&
                                                rowValue !== "0" && (
                                                    // <TableRow className="collapsible-row-child" key={i}>
                                                    //     <TableCell>
                                                    //         {keys[i] ||
                                                    //             keys[i].value ||
                                                    //             "Building " + keys[i].rowNumber}
                                                    //     </TableCell>
                                                    //     <TableCell className="bold-value">
                                                    //         {isArea
                                                    //             ? formatArea(rowValue?.value || rowValue)
                                                    //             : rowValue?.value || rowValue}
                                                    //     </TableCell>
                                                    // </TableRow>
                                                    <TableRow className="remove-bottom-border" key={keys[i]}>
                                                        <TableCell className="bold-value">
                                                            {/* {keys !== null ? (typeof keys[i] === "number" ? "Building " + keys[i] : keys[i]) : values[i].value
                                                    } */}
                                                            {keys[i]}
                                                            {/* {keys[i] ||
                                                        keys[i].value ||
                                                        "Building " + keys[i].rowNumber} */}
                                                        </TableCell>
                                                        <TableCell>
                                                            {isArea ? formatArea(rowValue) : rowValue}
                                                        </TableCell>
                                                    </TableRow>
                                                ),
                                        )}
                                </TableBody>
                            </Table>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        )
    );
};

const ChangeLocation = (data) => {
    const map = useMap();
    map.setView(data.location, data.zoom);
};

const DnvDevAppDetails = (props) => {
    const mapCenter = [49.337414, -123.070565];
    const [mapLocation, setMapLocation] = useState(mapCenter);
    const [selectedTab, setSelectedTab] = useState(0);
    const [applicationInfo, setApplicationInfo] = useState(null);
    const [images, setImages] = useState([]);
    const [leadImage, setLeadImage] = useState({});
    const [milestonesException, setMilestonesException] = useState([]);
    const [zoningLinks, setZoningLinks] = useState([]);
    const [error, setError] = useState(false);
    const northWestBound = { lat: 49.67, lng: -123.55 };
    const southEastBound = { lat: 48.96, lng: -122.6 };
    const bounds = L.latLngBounds(northWestBound, southEastBound);
    const crs = new L.Proj.CRS("EPSG:26910", "+proj=utm +zone=10 +ellps=GRS80 +datum=NAD83 +units=m +no_defs", {
        origin: [474584, 5480125],
        resolutions: [
            21.16670900008467, 10.583354500042335, 5.291677250021167, 2.6458386250105836, 1.3229193125052918,
            0.6614596562526459, 0.26458386250105836, 0.13229193125052918, 0.06614596562526459,
        ],
    });
    const [unitsSum, setUnitSum] = useState(0);

    const apiRootUrl = props.configuration.apiRootUrl;
    // const apiRootUrl = "https://localhost:7218/api/v1/significant-development-application";
    const caseNumber = props.configuration.caseNumber;

    const iconHTML = ReactDOMServer.renderToString(
        <FontAwesomeIcon icon={solid.faLocationDot} transform={"grow-16"} />,
    );

    const mapMarkerIcon = L.divIcon({
        html: iconHTML,
        iconSize: [20, 20],
        className: "marker",
    });

    const timelineTabs = [
        { id: 0, text: "Key dates" },
        { id: 1, text: "Full timeline" },
    ];
    const showToggle = true;
    const descriptionTextAlign = "start";
    const descriptionMaxLines = 3;

    const timelineIconCompleted = (
        <span className="fa-layers ">
            <FontAwesomeIcon icon={solid.faCircleCheck} size="lg" className="timeline-completed" title="completed" />
        </span>
    );
    const timelineIconUpcoming = (
        <span className="fa-layers ">
            <FontAwesomeIcon icon={solid.faCircleCalendar} size="lg" className="timeline-upcoming" title="upcoming" />
        </span>
    );

    const timelineIconUpcomingTBD = (
        <span className="fa-layers ">
            <FontAwesomeIcon
                icon={solid.faCircleEllipsis}
                size="lg"
                className="timeline-upcoming-tbd"
                title="upcoming tbd"
            />
        </span>
    );

    const timelineIconCurrent = (
        <span className="fa-layers ">
            <FontAwesomeIcon icon={solid.faCircleRight} size="lg" className="timeline-current" title="current" />
        </span>
    );

    const formatDate = (dateString, format) => {
        let date = new Date(dateString);
        let dateInZone = dayjs.tz(dateString, DATE_STORAGE_FORMAT, "America/Vancouver");
        // return dayjs(date).utc(true).local().format("YYYY-MM-DD");
        return dateInZone.format(format);
    };

    // for detailed applications "PLN"
    const planTimeline = [
        {
            title: "Permit issued",
            alternateTitle: "Council Consideration / Permit Issuance",
            startDate: applicationInfo?.milestonesCouncilConsidPermitIssD,
            endDate: null,
            url: null,
        },
        {
            title: "Bylaw adoption",
            alternateTitle: "Bylaw Adoption",
            startDate: applicationInfo?.milestonesBylawAdoptionD,
            endDate: null,
            url: null,
        },
        {
            title: "Second and third readings",
            alternateTitle: "2nd & 3rd Reading",
            startDate: applicationInfo?.milestonesSecondThirdReadingD,
            endDate: null,
            url: null,
        },
        {
            title: "Public hearing",
            alternateTitle: "Public Hearing",
            startDate: applicationInfo?.milestonesPublicHearingD,
            endDate: null,
            url: null,
        },
        {
            title: "Bylaw introduction",
            alternateTitle: "Bylaw Introduction - 1st Reading",
            startDate: applicationInfo?.milestonesBylawIntroD,
            endDate: null,
            url: null,
        },
        {
            title: "Public information meeting (virtual)",
            alternateTitle: "PIM Virtual",
            startDate: applicationInfo?.pLpivstartD,
            endDate: applicationInfo?.pLpivEndD,
            url: applicationInfo?.plZenCItyURLM,
        },
        {
            title: "Public information meeting (in person)",
            alternateTitle: "Public Information Meeting",
            startDate: applicationInfo?.milestonesPublicInfoMeetingD,
            endDate: null,
            url: null,
        },
		{
            title: "Detailed application received",
            alternateTitle: null,
            startDate: applicationInfo?.milestonesApplicationReceivedD,
            endDate: null,
            url: null,
        }
    ];  

    // workclass = "Development Permit Council (may include Variances)"
    const planTimelineDPC = [
        {
            title: "Permit issued",
            alternateTitle: "Council Consideration / Permit Issuance",
            startDate: applicationInfo?.milestonesCouncilConsidPermitIssD,
            endDate: null,
            url: null,
        },
        {
            title: "Public information meeting (virtual)",
            alternateTitle: "PIM Virtual",
            startDate: applicationInfo?.pLpivstartD,
            endDate: applicationInfo?.pLpivEndD,
            url: applicationInfo?.plZenCItyURLM,
        },
        {
            title: "Public information meeting (in person)",
            alternateTitle: "Public Information Meeting",
            startDate: applicationInfo?.milestonesPublicInfoMeetingD,
            endDate: null,
            url: null,
        },
		{
            title: "Application received",
            alternateTitle: null,
            startDate: applicationInfo?.milestonesApplicationReceivedD,
            endDate: null,
            url: null,
        }
    ]; 

    // for preliminary applications "PRE"
    const preTimeline = [
        {
            title: "Summary letter",
            alternateTitle: "",
            startDate: applicationInfo?.milestonesSummaryLetterD,
            endDate: null,
            url: null,
        },
        {
            title: "Council early input",
            alternateTitle: "Council early input",
            startDate: applicationInfo?.plCouncilearlyinputD,
            endDate: null,
            url: null,
        },
        {
            title: "Early input opportunity",
            alternateTitle: "Early Input Opportunity",
            startDate: applicationInfo?.milestonesEarlyInputD,
            endDate: null,
            url: null,
        },
        {
            title: "Preliminary application received",
            alternateTitle: "",
            startDate: applicationInfo?.milestonesApplicationReceivedD,
            endDate: null,
            url: null,
        },      
    ];  

    const tenureTypesList = ["Market Housing - Ownership", "Market Housing - Rental", "Social Housing - Rental", "Supportive Housing - Other", "Social Housing - Ownership"];

    const flattenExceptions = (exceptions) =>{
        const newExceptions = [];
        for(const exc of exceptions){
            const currentException = {
                    milestone: exc.Milestone ? exc.Milestone : exc["PL Milestone PRE"],
                    date: exc.Date ? exc.Date.substring(0, exc.Date.lastIndexOf(" ")).trim() : null,
                    internalNote: exc["Internal Note"],
                    exceptionType:  exc["Exception Type"]
                };
            newExceptions.push(currentException);
        }
        return newExceptions;
    }

    const extractMilestoneExceptions = ()=>{
        const exceptions = applicationInfo.planCustomFieldTableCells.filter((cell) => (cell.tableName === "PL Milestones Exceptions" || cell.tableName === "PL Milestones Exceptions PRE"));
        if(exceptions.length > 0){
            const flatExc = exceptions.reduce((acc, { columnName, rowNumber, value }) => {
                    if (!acc[rowNumber]) {
                    acc[rowNumber] = { rowNumber };
                    }
                    acc[rowNumber][columnName] = value;
                    return acc;
                }, {});

            if(milestonesException.length === 0){
                // setMilestonesException(Object.values(flatExc));
                const temp = Object.values(flatExc);
                const flatExcepts = flattenExceptions(temp);
                setMilestonesException(flatExcepts);
            }
        }
        buildTimeline();
    }

    const buildTimeline = () => {
        // extract milestone exceptions if there're any
        // extractMilestoneExceptions();
        let timeline = [];
        if(applicationInfo.caseNumber.indexOf("PLN") > -1){
            // work class = "Development Permit Council (may include Variances)"
            if(applicationInfo.planWorkClass === "Development Permit Council (may include Variances)"){
                timeline = planTimelineDPC;
            } else {
                timeline = planTimeline;
                // only show public hearing if type is 'PH Held'
                if(applicationInfo.milestonesPublicHearingType !== null && applicationInfo.milestonesPublicHearingType !== "PH Held"){
                    timeline = timeline.filter((p) => p.title.toLowerCase() !== "public hearing");
                }
            }

        } else {
            timeline = preTimeline;
        }
    
        return timeline;
    };

    const getTimelineDate = (step) =>{

        const currentException = milestonesException.filter((m) => step.alternateTitle && m.milestone.toLowerCase() === step.alternateTitle?.toLowerCase());
        
        let renderedDates;
        if(currentException.length === 1){
            if(currentException[0].exceptionType?.toLowerCase() === "rescheduled"){
                if(step.startDate){
                    renderedDates = formatDate(step.startDate, Config.dateFormat.date) +
                    " [new date]\n" + formatDate(new Date(currentException[0].date), Config.dateFormat.date) + " [postponed]";
                } else {
                    // new date not set, don't show TBD
                    renderedDates = formatDate(new Date(currentException[0].date), Config.dateFormat.date) + " [postponed]";
                }
               
            } else if(currentException[0].exceptionType?.toLowerCase() === "additional"){
            renderedDates = formatDate(step.startDate, Config.dateFormat.date) 
                    + " [session 2] \n" + 
                    formatDate(new Date(currentException[0].date), Config.dateFormat.date) + " [session 1]";
            } 
        } 
        else if (currentException.length === 2){
            const extended = currentException.filter((ce) => ce.exceptionType?.toLowerCase() === "additional");
            if(extended.length > 0){
                renderedDates = formatDate(step.startDate, Config.dateFormat.date) + " [session 2] \n" + formatDate(new Date(extended[0].date), Config.dateFormat.date) + " [session 1]\n";
            }
            
            const rescheduled = currentException.filter((ce) => ce.exceptionType?.toLowerCase() === "rescheduled");
            if(rescheduled.length > 0){
                renderedDates = renderedDates + formatDate(new Date(rescheduled[0].date), Config.dateFormat.date) + " [postponed]";
            }
            
        } 

        return (<span className="timeline-date">
            {currentException.length === 0 && 
                step.startDate &&
                formatDate(
                    step.startDate,
                    Config.dateFormat.date,
                )
            }

            {currentException.length === 0 && 
                !step.startDate &&
                <>TBD</>
            }

            {currentException.length === 0 && step.endDate !== null
                ? " to " +
                    formatDate(
                        step.endDate,
                        Config.dateFormat.date,
                    )
                : ""}

            {currentException.length > 0 &&
            (
                <>
                    {renderedDates}
                </>

            )}


        </span>);
    }

    const getTimelineStepStatus = (step) => {
        let todaysDateInZone = dayjs.tz(new Date(), DATE_STORAGE_FORMAT, "America/Vancouver");
        // set end of day for 'end date', ie 23:59:59
        let endDateEOD = null;
        if(step.endDate){
            endDateEOD = new Date(step.endDate).setHours(23, 59, 59, 0);
        }
        const validStartD = step.startDate !== undefined;
        if (validStartD && dayjs(step.startDate).isAfter(todaysDateInZone)) {
            return "upcoming";
        } else if (validStartD &&
            ((dayjs(step.startDate).isBefore(todaysDateInZone) && dayjs(endDateEOD).isAfter(todaysDateInZone)) ||
            dayjs(step.startDate).isSame(todaysDateInZone))
        ) {
            return "current";
        } else if (validStartD && dayjs(step.startDate).isBefore(todaysDateInZone)) {
            return "completed";
        } else { 
            // if rescheduled and no new date set
            // checking milestone is not null in case blank exception gets saved in energov
            const tlException = milestonesException.filter((m)=> m.milestone && m.milestone.toLowerCase() === step.alternateTitle?.toLowerCase());
            if(tlException.length > 0){
                if(tlException[0].exceptionType.toLowerCase() === "rescheduled"){
                    return "upcoming";
                }
            }
            
            return "upcomingTBD";
        }
    };

    const isDateInRange = (start, end) => {
        let todaysDateInZone = dayjs.tz(new Date(), DATE_STORAGE_FORMAT, "America/Vancouver");
        return dayjs(start).isBefore(todaysDateInZone) && dayjs(end).isAfter(todaysDateInZone);
    };

    const sortTimeline = (a, b) => {
        let distantFuture = new Date("January 1, 2925");
        let date1 = a.startDate === null ? distantFuture : new Date(a.startDate);
        let date2 = b.startDate === null ? distantFuture : new Date(b.startDate);
        return date2.getTime() - date1.getTime();
    };

    const getZoning = () =>{
        const arr = applicationInfo.zoningExistingS.toString().split(",");
        let zls = [];
        for(const z of arr){
            zls.push(getZoningLink(z.trim()));
        }
        setZoningLinks(zls);     
    }

    const getZoningLink = (type) => {
        if (type) {
            let url = "";
            switch (true) {
                case type.includes("RSE"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-edgemont-zone.pdf";
                    break;
                case type.includes("RSQ"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-queensdale.pdf";
                    break;
                case type.includes("RSPH"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-pemberton-heights.pdf";
                    break;
                case type.includes("RSNQ"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-norwood-queens.pdf";
                    break;
                case type.includes("RSSG"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-sunset-gardens.pdf";
                    break;
                case type.includes("RSK"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-kilmer.pdf";
                    break;
                case type.includes("RSMH"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-marlborough-heights.pdf";
                    break;
                case type.includes("RSKL"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-keith-lynn.pdf";
                    break;
                case type.includes("RSH"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-highlands.pdf";
                    break;
                case type.includes("RSEW"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-edgemont-west.pdf";
                    break;
                case type.includes("RSD"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-delbrook.pdf";
                    break;
                case type.includes("RSCH"):
                    url = "https://dnv-docs.simplicitycms.ca/documents/RSCH-zoning-guide.pdf";
                    break;
                case type.includes("RSN"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-norgate.pdf";
                    break;
                case type.includes("RSMF"):
                    url =
                        "https://dnv-docs.simplicitycms.ca/documents/zoning-guide-single-family-residential-murdo-frazer.pdf";
                    break;
                case type.includes("RS"):
                    url = "https://docs.dnv.org/documents/zoning-guide-single-family-residential-1-5.pdf";
                    break;
                default:
                    break;
            }

            // if (url === "") {
            //     return type;
            // }

           // return <Link to={url}>{type}</Link>;
           return {link: url, type}
        }
    };

    const getDPALink = (type) => {
        if (applicationInfo[type] === true) {
            switch (type) {
                case "dpSlopeHazB":
                    return (
                        <div key={type}>
                            <Link to="/business-development/slope-hazard-development-permit-area-dpa">
                                Slope Hazard DPA
                            </Link>
                        </div>
                    );
                case "dpStreamsideProtB":
                    return (
                        <div key={type}>
                            <Link to="/business-development/streamside-protection-development-permit-area-dpa">
                                Streamside Protection DPA
                            </Link>
                        </div>
                    );
                case "dpEnergyWaterGhgB":
                    return (
                        <div key={type}>
                            <Link to="/business-development/energy-water-and-greenhouse-gas-development-permit-area-dpa">
                                Energy & Water Conservation & GHG Reduction DPA
                            </Link>
                        </div>
                    );
                case "dpCreekHazB":
                    return (
                        <div key={type}>
                            <Link to="/business-development/creek-hazard-development-permit-area-dpa">
                                Creek Hazard DPA
                            </Link>
                        </div>
                    );
                case "dpWildfireHazB":
                    return (
                        <div key={type}>
                            <Link to="/business-development/wildfire-hazard-development-permit-area-dpa">
                                Wildfire Hazard DPA
                            </Link>
                        </div>
                    );
                case "dpNatEnvProtB":
                    return (
                        <div key={type}>
                            <Link to="/business-development/natural-environment-development-permit-area-dpa">
                                Natural Environment DPA
                            </Link>
                        </div>
                    );
                case "dpFormCharacterB":
                    return (
                        <div key={type}>
                            <Link to="/business-development/form-and-character-development-permit-area-dpa">
                                Form and Character DPA
                            </Link>
                        </div>
                    );
                default:
                    return <></>;
            }
        }
    };

    const formatLotArea = (hectares) => {
        return hectares + " ha / " + Math.round(hectares * 2.471 * 10) / 10 + " ac";
    };

    const formatArea = (squareMetres) => {
        const squareFt = Math.round(squareMetres * 10.7639);
        return (
            <span className="wrap">
                {squareMetres !== null && (
                    <span className="no-wrap">
                        {Math.round(squareMetres).toLocaleString("en-CA")} m<sup>2</sup>&nbsp;/ 
                    </span>
                )}
                {/* {squareMetres !== null && squareFt !== null && <span> / </span>} */}
                {squareFt !== null && (
                    <span className="no-wrap">
                        {" "}{squareFt.toLocaleString("en-CA")} ft<sup>2</sup>
                    </span>
                )}
            </span>
        );
    };

    const formatHeight = (metres) => {
        return metres + " m / " + Math.round(metres * 3.281 * 10) / 10 + " ft";
    };

    const getTenureInfo = () => {
        let tenureTypes = applicationInfo.planCustomFieldTableCells
            .filter((field) => field.tableName === "Pl Unit Info Proposed" && field.columnName === "Tenure")
            .map((field) => field.value);
        // filter out items not in tenureTypesList
        tenureTypes = tenureTypes.filter((t) => tenureTypesList.includes(t));
        let totalUnitsByType = [];
        let tenureObj = [];
        for (let type of tenureTypes) {
            let rowNumbersForCurrentType = applicationInfo.planCustomFieldTableCells
                .filter((field) => field.value === type)
                .map((field) => field.rowNumber);
            let totalUnitsCurrentType = applicationInfo.planCustomFieldTableCells
                .filter((field) => rowNumbersForCurrentType.includes(field.rowNumber) && field.columnName === "Count")
                .map((field) => Number(field.value))
                .reduce((a, b) => a + b);

            // only add to array if not in it
            const inList = tenureObj.filter((t) => t.type === type);
            if(inList.length === 0){
                tenureObj.push({
                    type, total: totalUnitsCurrentType
                });
            }

        }

        const tempTenureTypes = tenureObj.map((to) => to.type);
        const tempTenureTotals = tenureObj.map((to) => to.total);

        return { tenureTypes: tempTenureTypes, totalUnitsByType: tempTenureTotals };
        
    };

    const sum = (arr) => {
        let sumVal = 0;
        for (const number of arr) {
            sumVal += number;
        }
        return sumVal;
    }

    const getStoreys = () => {
        let storeysArray = applicationInfo.planCustomFieldTableCells
            .filter((field) => field.tableName === "Pl Building Proposed" && field.columnName === "Storeys")
            .map((a) => a.value);
        if (new Set(storeysArray).size === 1) {
            return storeysArray[0];
        } else if (new Set(storeysArray).size === 0) {
            return "N/A";
        } else {
            return (
                Math.min(
                    ...applicationInfo.planCustomFieldTableCells
                        .filter((field) => field.tableName === "Pl Building Proposed" && field.columnName === "Storeys")
                        .map((a) => a.value),
                ) +
                " to " +
                Math.max(
                    ...applicationInfo.planCustomFieldTableCells
                        .filter((field) => field.tableName === "Pl Building Proposed" && field.columnName === "Storeys")
                        .map((a) => a.value),
                )
            );
        }
    };

    const getContentLinks = (tableName) => {
        let documents = [];

        let documentsInfo = applicationInfo.planCustomFieldTableCells.filter((field) => field.tableName === tableName);
        let numRows = Math.max(...documentsInfo.map((info) => info.rowNumber));

        for (let i = 0; i <= numRows; i++) {
            let url = documentsInfo.find((cell) => cell.columnName === "URL" && cell.rowNumber === i)?.value;
            let description = documentsInfo.find(
                (cell) => cell.columnName === "Description" && cell.rowNumber === i,
            )?.value;

            if (url && description) {
                documents.push({ url: url, description: description });
            }
        }

        if (tableName === "PL - Sig Dev Web Content") {
            switch (applicationInfo.ocpTownCentreP) {
                case "Lynn Creek Town Centre":
                    documents.push({
                        url: "/community-environment/lynn-creek-town-centre",
                        description: "Lynn Creek Town Centre",
                    });
                    break;
                case "Lynn Valley Town Centre":
                    documents.push({
                        url: "/community-environment/lynn-valley-town-centre",
                        description: "Lynn Valley Town Centre",
                    });
                    break;
                case "Lions Gate Village Centre":
                    documents.push({
                        url: "/community-environment/lions-gate-village",
                        description: "Lions Gate Village Centre",
                    });
                    break;
                case "Edgemont Village Centre":
                    documents.push({
                        url: "/community-environment/edgemont-village",
                        description: "Edgemont Village Centre",
                    });
                    break;
                case "Maplewood Village Centre":
                    documents.push({
                        url: "/community-environment/maplewood-village-centre-and-area",
                        description: "Maplewood Village Centre",
                    });
                    break;
                default:
                    break;
            }
        }

        return documents;
    };

    const getImageInfo = () => {
        //todo: combine with getContentLinks()

        let images = [];
        let imageInfo = applicationInfo.planCustomFieldTableCells.filter(
            (field) => field.tableName === "PL - Sig Dev Images",
        );
        let numRows = Math.max(...imageInfo.map((info) => info.rowNumber));

        for (let i = 0; i <= numRows; i++) {
            let url = imageInfo.find((cell) => cell.columnName === "URL" && cell.rowNumber === i)?.value;
            let description = imageInfo.find(
                (cell) => cell.columnName === "Description" && cell.rowNumber === i,
            )?.value;
            let altText = imageInfo.find((cell) => cell.columnName === "Alternate Text" && cell.rowNumber === i)?.value;
            let isLeadImage =
                imageInfo.find((cell) => cell.columnName === "Lead Image" && cell.rowNumber === i)?.value === "1";

            if (url) {
                if (isLeadImage) {
                    setLeadImage({ src: url, description: description || "", alt: altText || "" });
                }
                images.push({ src: url, description: description || "", alt: altText || "" });
            }
        }
        setImages(images);
    };

    const getApplicationInfo = async () => {
        devAppService
            .getDevelopmentApplicationCached(apiRootUrl, caseNumber)
            // todo: what to return if case number is not found
            .then(async (res) => {
                setApplicationInfo(res.data);
                setMapLocation([res.data.latitude, res.data.longitude]);
            }).catch(error => {
                setError(true);
                // if(error.status === 404){
                //     console.log(error.response.data);
                // } else {
                //     console.log(error.response.data);
                // }
            });
    };

    const formatPostalCode = () => {
        const pc = applicationInfo.planCaseAddresses.find((address) => address.isMain).postalCode;
        let postalCode = "";
        if (pc.indexOf(" ") === -1) {
            postalCode = pc.substring(0, 3) + " " + pc.substring(3);
        } else {
            postalCode = pc;
        }
        return postalCode;
    };

    const isPlannerBlank = () => {
        let result = false;
        if(isNullOrEmpty(applicationInfo.planner.company) && isNullOrEmpty(applicationInfo.planner.email) && isNullOrEmpty(applicationInfo.planner.name) && isNullOrEmpty(applicationInfo.planner.phone)){
            result = true;
        }
        return result;
    }

    const setEndOfDay = () =>{
        if(applicationInfo.pLpivEndD){
            const temp = new Date(applicationInfo.pLpivEndD).setHours(23,59,59,0);
            applicationInfo.pLpivEndD = temp;
        }
    }

    useEffect(() => {
        getApplicationInfo();
    }, []);

    useEffect(() => {
        if (applicationInfo) {
            getImageInfo();
            extractMilestoneExceptions();
            getZoning();
            setEndOfDay();
        }
    }, [applicationInfo]);

    return (
        <>
            {applicationInfo && (
                <div className="dev-apps-details">
                    {images && <img src={leadImage.src} alt={leadImage.alt} className="lead-image"></img>}
                    {applicationInfo.plWebDescriptionM && (
                        <div className="description">
                            <h2>Description</h2>
                            {applicationInfo.plWebDescriptionM.replace("&#178;", "²")}
                        </div>
                    )}

                    {isDateInRange(applicationInfo.pLpivstartD, applicationInfo.pLpivEndD) &&
                        applicationInfo.plZenCItyURLM && (
                            <div
                                className="simplicity-info-box"
                                role="region"
                                aria-labelledby="information-block-title"
                            >
                                <div className="simplicity-info-box-icon">
                                    <span className="fa-layers fa-fw fa-lg">
                                        <FontAwesomeIcon icon={faMessage} transform={"grow-9"} />
                                        <FontAwesomeIcon
                                            icon={faInfo}
                                            transform={"shrink-4 up-3"}
                                            className={"font-awesome-icon-layer"}
                                        />
                                    </span>
                                </div>
                                <div className="simplicity-info-box-content">
                                    <div className="rich-text-container">
                                        <p>
                                            The{" "}
                                            <Link to={applicationInfo.plZenCItyURLM}>Public Information Meeting</Link>{" "}
                                            for
                                            <span className="address">
                                                {applicationInfo.planCaseAddresses
                                                    .find((address) => address.isMain)
                                                    .address.toLowerCase()}
                                            </span>{" "}
                                            is now open and will remain accessible until{" "}
                                            {formatDate(applicationInfo.pLpivEndD, Config.dateFormat.date)} at{" "}
                                            {formatDate(applicationInfo.pLpivEndD, Config.dateFormat.time)}.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}

                    <div className="tables project-details">
                        <div className="left">
                            <h3 className="section-header">Project details</h3>
                            <Table className="collapsible-table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="bold-value">Project name</TableCell>
                                        <TableCell>{applicationInfo.prjProjectNameS}</TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="bold-value">Submitted date</TableCell>
                                        <TableCell>
                                            {formatDate(
                                                applicationInfo.milestonesApplicationReceivedD,
                                                Config.dateFormat.date,
                                            )}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="bold-value">Status</TableCell>
                                        <TableCell>
                                            {getPlanStatusByType(applicationInfo)}
                                        </TableCell>
                                    </TableRow>
                                    {applicationInfo.developer !== null &&
                                        Object.values(applicationInfo.developer).some((val) => val && val !== "") && (
                                            <TableRow className="single-cell-data">
                                                <TableCell colSpan={2} className="left-align">
                                                    <div className="div-head">Applicant</div>
                                                    {(!isNullOrEmpty(applicationInfo.developer.name) || !isNullOrEmpty(applicationInfo.developer.company)) && 
                                                    <span className="developer-name">
                                                        {applicationInfo.developer.name !== "" &&
                                                            applicationInfo.developer.name}
                                                        {applicationInfo.developer.company &&
                                                          ", " + applicationInfo.developer.company}
                                                    </span>
                                                    }
                                                    
                                                    {!isNullOrEmpty(applicationInfo.developer.email) && <span className="developer-contact">
                                                        <FontAwesomeIcon icon={solid.faEnvelope} />
                                                        <a href={"mailto:" + (applicationInfo.developer.email || "")}>
                                                            {applicationInfo.developer.email}
                                                        </a>
                                                    </span>}
                                                    
                                                    {!isNullOrEmpty(applicationInfo.developer.phone) && <span className="developer-contact">
                                                        {applicationInfo.developer.phone &&
                                                            applicationInfo.developer.phone.length > 0 && (
                                                                <>
                                                                    <FontAwesomeIcon icon={solid.faPhone} />
                                                                    {applicationInfo.developer.phone}
                                                                </>
                                                            )}
                                                    </span>}
                                                    
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    {applicationInfo.planner !== null &&
                                        Object.values(applicationInfo.planner).some((val) => val && val !== "") && (
                                            <TableRow className="single-cell-data">
                                                <TableCell colSpan={2} className="left-align">
                                                    <div className="div-head">Planner</div>

                                                    {applicationInfo.planner.name !== "" && (
                                                        <span className="developer-name">
                                                            {applicationInfo.planner.name}
                                                        </span>
                                                    )}
                                                    {!isNullOrEmpty(applicationInfo.planner.email) && (
                                                        <span className="developer-contact">
                                                            <FontAwesomeIcon icon={solid.faEnvelope} />
                                                            <a
                                                                href={
                                                                    "mailto:" + (applicationInfo.planner?.email || "")
                                                                }
                                                            >{applicationInfo.planner?.email}
                                                            </a>
                                                        </span>
                                                    )}
                                                    {!isNullOrEmpty(applicationInfo.planner.phone) && (
                                                            <span className="developer-contact">
                                                                <FontAwesomeIcon icon={solid.faPhone} />
                                                                {applicationInfo.planner?.phone}
                                                            </span>
                                                        )}

                                                     {isPlannerBlank() && 
                                                        <span>
                                                        Contact us at <a href="mailto:planning@dnv.org">planning@dnv.org</a> or 604.990.2480
                                                        </span>
                                                        }
                                                </TableCell>
                                            </TableRow>
                                        )}
                                </TableBody>
                            </Table>

                            <h3 className="section-header">Lot characteristics</h3>
                            <Table className="collapsible-table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="bold-value">Total lot area</TableCell>
                                        <TableCell className="pl-5">
                                            {applicationInfo.siteAreaN !== null && (
                                                <span className='no-wrap'>
                                                    {Math.round(applicationInfo.siteAreaN).toLocaleString("en-CA")} m
                                                    <sup>2</sup>&nbsp;/
                                                </span>
                                            )}{" "}
                                            {/* {applicationInfo.siteAreaN !== null &&
                                                applicationInfo.siteAreaFtN !== null && <span> / </span>} */}
                                            {applicationInfo.siteAreaFtN !== null && (
                                                <span className='no-wrap'>
                                                    {Math.round(applicationInfo.siteAreaFtN).toLocaleString("en-CA")} ft
                                                    <sup>2</sup>
                                                </span>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="bold-value">Current zoning</TableCell>
                                        <TableCell>
                                          {zoningLinks.map((z, index) => (
                                            <span key={z.type}>
                                            {z.link.length > 0 ? (
                                                <>
                                               <Link to={z.link}>{z.type}</Link>
                                               
                                               </>
                                            ) : (
                                                <>{z.type}
                                                 
                                                </>
                                            )}
                                           {index < zoningLinks.length - 1 && (
                                            <>{", "}</>
                                            )}
                                            </span>
                                            
                                        ))}
                                            
                                        </TableCell>
                                    </TableRow>
                                    <TableRow className="single-cell-data">
                                        <TableCell colSpan={2} className="left-align">
                                            <div className="bold-value">Official Community Plan designation</div>
                                            <span>{applicationInfo.ocpDesignationExistingP}</span>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow className="single-cell-data">
                                        <TableCell colSpan={2} className="left-align list">
                                            <div className="bold-value">Applicable Development Permit Areas</div>
                                            {[
                                                "dpCreekHazB",
                                                "dpEnergyWaterGhgB",
                                                "dpFormCharacterB",
                                                "dpNatEnvProtB",
                                                "dpSlopeHazB",
                                                "dpStreamsideProtB",
                                                "dpWildfireHazB",
                                            ].map((dpa) => getDPALink(dpa))}
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>

                            <h3 className="section-header">Building details</h3>
                            <Table className="collapsible-table">
                                <TableBody>
                                    <TableRow>
                                        <TableCell className="bold-value">Development type</TableCell>
                                        <TableCell>
                                            {getDevelopmentTypes(
                                                applicationInfo.planCustomFieldTableCells.filter(
                                                    (field) => field.tableName === "Pl Building Proposed",
                                                ),
                                            )}
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell className="bold-value">Number of buildings</TableCell>
                                        <TableCell>
                                            {
                                                applicationInfo.planCustomFieldTableCells.filter((r) => r.tableName === "Pl Building Proposed" && r.columnName === "Building ID").length
                                            }
                                        </TableCell>
                                    </TableRow>
                                    {applicationInfo.planCustomFieldTableCells
                                        .filter(
                                            (field) =>
                                                field.tableName === "Pl Building Proposed" &&
                                                field.columnName === "Storeys",
                                        )
                                        .map((a) => a.value).length <= 1 ? (
                                        <TableRow>
                                            <TableCell className="bold-value">Storeys</TableCell>
                                            <TableCell>{getStoreys()}</TableCell>
                                        </TableRow>
                                    ) : (
                                        <CollapsibleRow
                                            fieldName="Storeys"
                                            fieldValue={getStoreys()}
                                            keys={applicationInfo.planCustomFieldTableCells
                                                .filter(
                                                    (field) =>
                                                        field.tableName === "Pl Building Proposed" &&
                                                        field.columnName === "Name",
                                                )
                                                .map((a) => a.value)
                                                .map((value, ind) => {
                                                    let alphabet = "abcdefghijklmnopqrstuvwxyz".split("");
                                                    if (value === null) {
                                                        return "Building " + alphabet[ind].toUpperCase();
                                                    }
                                                    return value;
                                                })}
                                            values={applicationInfo.planCustomFieldTableCells
                                                .filter(
                                                    (field) =>
                                                        field.tableName === "Pl Building Proposed" &&
                                                        field.columnName === "Storeys",
                                                )
                                                .map((a) => a.value)}
                                        />
                                    )}
                                </TableBody>
                            </Table>

                            <h3 className="section-header">Use and density</h3>
                            <Table className="collapsible-table area">
                                <TableBody>
                                    <CollapsibleRow
                                        fieldName="Total floor space"
                                        fieldValue={formatArea(applicationInfo.plpropTotalFlrSpcN)}
                                        isArea={true}
                                        keys={["Apartment", "Commercial", "Institutional", "Industrial", "Townhouse"]}
                                        values={[
                                            Math.round(applicationInfo.plPropResFlrSPcSum),
                                            Math.round(applicationInfo.plPropComFlrSPcSum),
                                            Math.round(applicationInfo.plPropInsFlrSPcSum),
                                            Math.round(applicationInfo.plPropIndFlrSPcSum),
                                            Math.round(applicationInfo.plPropTownFlrSPcSum),
                                        ]}
                                    />

                                    <TableRow>
                                        <TableCell className="bold-value">Total development density</TableCell>
                                        {applicationInfo.plpropTotalFlrSpcN !== null &&
                                            applicationInfo.siteAreaN !== null && (
                                                <TableCell>
                                                    {Math.round(
                                                        (applicationInfo.plpropTotalFlrSpcN /
                                                            applicationInfo.siteAreaN) *
                                                            10,
                                                    ) /
                                                        10 +
                                                        " FSR"}
                                                </TableCell>
                                            )}
                                    </TableRow>
                                </TableBody>
                            </Table>
                             {applicationInfo.plunitcountSUM > 0 && (
                                <>
                                    <h3 className="section-header">Residential units</h3>
                                    <Table className="collapsible-table">
                                        <TableBody>
                                            <CollapsibleRow
                                                className="collapsible-row"
                                                fieldName="Total units"
                                                fieldValue={sum(getTenureInfo().totalUnitsByType)}
                                                isArea={false}
                                                keys={getTenureInfo().tenureTypes}
                                                values={getTenureInfo().totalUnitsByType}
                                            />
                                        </TableBody>
                                    </Table>
                                </>
                            )}

                            <h3 className="section-header">Parking details</h3>
                            <Table className="collapsible-table">
                                <TableBody>
                                    {applicationInfo.plpropTotalParkSpcN === 0 ? (
                                        <TableRow>
                                            <TableCell className="bold-value">Vehicle spaces</TableCell>
                                            <TableCell>0</TableCell>
                                        </TableRow>
                                    ) : (
                                        <CollapsibleRow
                                            fieldName="Vehicle spaces"
                                            fieldValue={applicationInfo.plpropTotalParkSpcN}
                                            isArea={false}
                                            keys={[
                                                "Residential",
                                                "Commercial",
                                                "Institutional",
                                                "Industrial",
                                                "Visitor",
                                            ]}
                                            values={[
                                                applicationInfo.plpropResParkSUM,
                                                applicationInfo.plpropComParkSUM,
                                                applicationInfo.plpropInsParkSUM,
                                                applicationInfo.plpropIndParkSUM,
                                                applicationInfo.plpropVisParkSUM,
                                            ]}
                                        />
                                    )}
                                </TableBody>
                            </Table>
                        </div>

                        <div className="right">
                            <h3 className="section-header">Location</h3>
                            <div className="details-section location-address">
                                {applicationInfo.planCaseAddresses
                                    .find((address) => address.isMain)
                                    .address.toLowerCase()}
                                <br />
                                North Vancouver, BC {formatPostalCode()}
                            </div>

                            <MapContainer
                                // center={mapLocation}
                                scrollWheelZoom="center"
                                style={{ height: "444px", marginBottom: "32px" }}
                                className="map"
                                zoomControl={false}
                                minZoom={0}
                                maxZoom={8}
                                maxBounds={bounds}
                                crs={crs}
                            >
                                <ZoomControl position="topright" />
                                <TileLayer url="https://www.geoweb.dnv.org/arcgis/rest/services/Basemap_Canvas/MapServer/tile/{z}/{y}/{x}" />
                                {/* <Polygon pathOptions={{ color: "#196069" }} positions={polygonInfo} /> */}
                                <Marker position={mapLocation} icon={mapMarkerIcon} />
                                {/* "zoom" here sets default map zoom */}
                                <ChangeLocation location={mapLocation} zoom={5} />
                            </MapContainer>

                            <h3 className="section-header">Timeline</h3>
                            <Tabs
                                customContainerClassName="timeline"
                                tabs={timelineTabs}
                                selected={selectedTab}
                                setSelected={(id) => setSelectedTab(id)}
                            >
                                {/* key dates */}
                                <TabContent id={0} tab={timelineTabs[0]} selected={selectedTab}>
                                    <Stepper orientation="vertical" className="timeline">
                                        {buildTimeline()
                                            // .filter((step) => step.startDate !== null)
                                            .map((step, index) => (
                                                <Step key={step.title + "-kd" + index}>
                                                    {getTimelineStepStatus(step) === "completed" && (
                                                        <StepLabel
                                                            icon={timelineIconCompleted}
                                                            optional={getTimelineDate(step)
                                                                
                                                            }
                                                        >
                                                            {step.title}
                                                        </StepLabel>
                                                    )}
                                                    {getTimelineStepStatus(step) === "current" && (
                                                        <StepLabel
                                                            icon={timelineIconCurrent}
                                                            optional={
                                                                <>
                                                                    {getTimelineDate(step)}
                                                                    {step.url && (
                                                                        <Button
                                                                            className="btn-participate"
                                                                            href={step.url}
                                                                            target="_blank"
                                                                            title="Participate now"
                                                                            disableRipple
                                                                        >
                                                                            Participate now
                                                                        </Button>
                                                                    )}
                                                                </>
                                                            }
                                                        >
                                                            {step.title}
                                                        </StepLabel>
                                                    )}
                                                    {getTimelineStepStatus(step) === "upcoming" && (
                                                        <StepLabel
                                                            icon={timelineIconUpcoming}
                                                            optional={
                                                                getTimelineDate(step)
                                                            }
                                                        >
                                                            {step.title}
                                                        </StepLabel>
                                                    )}
                                                </Step>
                                            ))}
                                    </Stepper>
                                </TabContent>

                                {/* full timeline */}
                                <TabContent
                                    id={1}
                                    tab={timelineTabs[1]}
                                    selected={selectedTab}
                                    className="details-section timeline"
                                >
                                    <Stepper orientation="vertical" className="timeline">
                                        {buildTimeline()
                                            .map((step, index) => (
                                                <Step key={step.title + "-tl" + index}>
                                                    {getTimelineStepStatus(step) === "completed" && (
                                                        <StepLabel
                                                            icon={timelineIconCompleted}
                                                            optional={
                                                                getTimelineDate(step)
                                                            }
                                                        >
                                                            {step.title}
                                                        </StepLabel>
                                                    )}
                                                    {getTimelineStepStatus(step) === "current" && (
                                                        <StepLabel
                                                            icon={timelineIconCurrent}
                                                            optional={
                                                                getTimelineDate(step)
                                                            }
                                                        >
                                                            {step.title}
                                                        </StepLabel>
                                                    )}
                                                    {getTimelineStepStatus(step) === "upcoming" && (
                                                        <StepLabel
                                                            icon={timelineIconUpcoming}
                                                            optional={
                                                                getTimelineDate(step)
                                                            }
                                                        >
                                                            {step.title}
                                                        </StepLabel>
                                                    )}
                                                    {getTimelineStepStatus(step) === "upcomingTBD" && (
                                                        <StepLabel
                                                            icon={timelineIconUpcomingTBD}
                                                            optional=
                                                            {
                                                                getTimelineDate(step)
                                                            }
                                                        >
                                                            {step.title}
                                                        </StepLabel>
                                                    )}
                                                </Step>
                                            ))}
                                    </Stepper>
                                </TabContent>
                            </Tabs>

                            {/* web pages open in same tab, documents open in separate tab */}
                            {getContentLinks("PL - Sig Dev Documents").length > 0 && (
                                <>
                                    <h3 className="section-header">Documents</h3>
                                    <div className="details-section links pdf">
                                        <ul>
                                            {getContentLinks("PL - Sig Dev Documents").map((document, ind) => {
                                                return (
                                                    <li key={"docs" + ind}>
                                                        <a href={document.url} target="_blank">
                                                            <span className="pdf-icon">
                                                            <FontAwesomeIcon icon={solid.faFilePdf}></FontAwesomeIcon>
                                                            </span>
                                                            <span className="">
                                                            {document.description}
                                                            </span>
                                                        </a>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </>
                            )}

                            {getContentLinks("PL - Sig Dev Web Content").length > 0 && (
                                <>
                                    <h3 className="section-header">Related web content</h3>
                                    <div className="details-section links">
                                        <ul>
                                            {/* default links */}
                                            <li>
                                                <Link to="/community-environment/our-official-community-plan-ocp">
                                                    Official Community Plan (OCP)
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/business-development/official-community-plan-land-use-map">
                                                    OCP land use map
                                                </Link>
                                            </li>
                                            <li>
                                                <Link to="/business-development/development-permit-areas-dpa">
                                                    Development permit areas
                                                </Link>
                                            </li>

                                            {/* custom links */}
                                            {getContentLinks("PL - Sig Dev Web Content").map((link, ind) => {
                                                return (
                                                    <li key={"links" + ind}>
                                                        <Link to={link.url}>{link.description}</Link>
                                                    </li>
                                                );
                                            })}
                                        </ul>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    {images.length > 0 && (
                        <>
                            <h3>Photos, drawings, renderings</h3>
                            <div className="field field-image image_gallery">
                                <Lightbox
                                    slides={images}
                                    inline={{
                                        style: {
                                            width: "100%",
                                            maxWidth: "none",
                                            aspectRatio: "3 / 2",
                                            margin: "0 auto",
                                        },
                                    }}
                                    captions={{ showToggle, descriptionTextAlign, descriptionMaxLines }}
                                    plugins={[Inline, Thumbnails, Captions, Fullscreen, Zoom]}
                                    render={{
                                        iconPrev: () => <FontAwesomeIcon icon={solid.faCircleChevronLeft} />,
                                        iconNext: () => <FontAwesomeIcon icon={solid.faCircleChevronRight} />,
                                        iconEnterFullscreen: () => <FontAwesomeIcon icon={solid.faExpand} />,
                                        iconExitFullscreen: () => <FontAwesomeIcon icon={solid.faCompress} />,
                                        iconZoomIn: () => <FontAwesomeIcon icon={solid.faMagnifyingGlassPlus} />,
                                        iconZoomOut: () => <FontAwesomeIcon icon={solid.faMagnifyingGlassMinus} />,
                                        iconCaptionsVisible: () => <FontAwesomeIcon icon={solid.faClosedCaptioning} />,
                                        iconCaptionsHidden: () => <FontAwesomeIcon icon={regular.faClosedCaptioning} />
                                    }}
                                />

                            </div>
                        </>
                    )}
                </div>
            )}
            {error && (
                <DnvDevAppError></DnvDevAppError>
            )
                
            }

        </>
    );
};

DnvDevAppDetails.displayName = "DnvDevAppDetails";
export { DnvDevAppDetails };
